// Vendors
import { useIntl } from 'react-intl';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Types
import { EntrypointOrchestratorUncategorizedHookType } from 'entrypoint/components/orchestrator/components/uncategorized/hooks/types/entrypoint-orchestrator-uncategorized.hook.type';

const useEntrypointOrchestratorUncategorizedHook =
  (): EntrypointOrchestratorUncategorizedHookType => {
    const { currentState } = useAppContextConsumerHook(),
      { formatMessage } = useIntl();

    return {
      currentState,
      formatMessage,
    };
  };

export { useEntrypointOrchestratorUncategorizedHook };
